<ecu-dialog
  [title]="'cardterminals.pin.title' | translate"
  [primaryButtonLabel]="'globals.copy' | translate"
  [secondaryButtonLabel]="'globals.close' | translate"
  [isPrimaryButtonDisabled]="!pin"
  [isPrimaryButtonLoading]="isLoading"
  (primaryButtonClick)="copyPin()"
  (secondaryButtonClick)="close()"
>
  <div *ngIf="isLoading" class="text-center" style="min-width: 300px">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <div *ngIf="pin && !isLoading" style="min-width: 300px">
    <p>{{ 'cardterminals.pin.text' | translate: { label: data.label } }}</p>
    <mat-form-field>
      <mat-label>{{ 'cardterminals.pin.label' | translate }}</mat-label>
      <input matInput [value]="pin" readonly />
      <mat-icon matSuffix (click)="copyPin()" style="cursor: pointer">content_copy</mat-icon>
    </mat-form-field>
    <p>{{ 'cardterminals.pin.secret' | translate }}</p>
  </div>
</ecu-dialog>
